module.exports = __webpack_public_path__ + "static/assets/b27892fc2ccb732f6aa447f20dca1952.svg";